import { render, staticRenderFns } from "./TabNDV.vue?vue&type=template&id=37a244d6&"
import script from "./TabNDV.vue?vue&type=script&lang=ts&"
export * from "./TabNDV.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports